class BarHidden {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    if($(location).attr('href').match(/_x_tr_sl=/)) {
      const body = document.querySelector("body")
      body.classList.add("mt-none")
    }
  }
}
